/* src/app/components/doc-viewer-new/form-controls/icon-button/icon-button.component.scss */
.icon {
  --fa-primary-color: #FFF;
  --fa-secondary-color: #8f9ae0;
  --fa-secondary-opacity: 1 ;
}
.single-color-icon {
  color: #FFF;
}
.close-icon {
  --fa-primary-color: #FFF;
  --fa-secondary-color: #FFF;
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color: #373636;
}
:host-context(.dark-theme) .single-color-icon {
  color: #FFC107;
}
:host-context(.dark-theme) .close-icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color: #FFC107;
}
button {
  color: #FFF;
  background: #3949AB;
}
:host-context(.dark-theme) button {
  background: #000;
}
.disabled {
  --fa-primary-color: #3d3d3d;
  --fa-secondary-color: #6d6d6d;
}
:host-context(.dark-theme) .disabled {
  --fa-primary-color: #6d6d6d;
  --fa-secondary-color: #6d6d6d;
}
.hide-background {
  background-color: inherit !important;
}
/*# sourceMappingURL=icon-button.component.css.map */
